import { render, staticRenderFns } from "./TraxUiAjaxTableWithActions.vue?vue&type=template&id=86d68938"
import script from "./TraxUiAjaxTableWithActions.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxTableWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports